import React, { useEffect, useState } from "react";
import axios from "axios";
import { Card, Spinner, Row, Col } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import Cookies from "js-cookie";
import { Link } from "react-router-dom";
import logo from "../../../assets/irc-logo-rb.png";
import { FaHome, FaFolder } from "react-icons/fa";
import { getNodeApiBase } from "../../../utils/apiBase";

const cardStyle = {
  borderRadius: "18px",
  boxShadow: "0 8px 32px rgba(0,0,0,0.12)",
  background: "#fff",
  border: "none",
  minWidth: "550px",
  maxWidth: "600px",
  width: "100%",
};

const headerStyle = {
  background: "#0f7b47",
  color: "#fff",
  borderTopLeftRadius: "18px",
  borderTopRightRadius: "18px",
  padding: "1.5rem 1rem",
  textAlign: "center",
  fontWeight: 700,
  fontSize: "1.7rem",
  letterSpacing: "1px",
};

const labelStyle = {
  color: "#0f7b47",
  fontWeight: 600,
  fontSize: "1.08rem",
};

const valueStyle = {
  color: "#22223b",
  fontWeight: 500,
  fontSize: "1.08rem",
};

const sidebarWidth = 220; // px

const CompteEvaluateur = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const nodeApiBase = getNodeApiBase();

  useEffect(() => {
    // Get the email from cookies or localStorage (depending on your login logic)
    const email = localStorage.getItem("email") || Cookies.get("email") || "";

    // Use the backend-evaluateur Node.js API endpoint
    axios
      .get(`${nodeApiBase}/api/evaluateur/info`, { params: { email } })
      .then((res) => {
        setUser(res.data.user);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [nodeApiBase]);

  // Dummy handleToggleSidebar function (since not provided)
  const handleToggleSidebar = () => {};

  return (
    <div
      style={{
        minHeight: "60vh",
        background: "#e4d2d2",
        display: "flex",
        flexDirection: "row",
      }}
    >
      {/* Sidebar */}
      <div className="sidebar">
        <div className="logo-container">
          <img src={logo} alt="IRC Logo" className="logo" />
        </div>
        <Link to="/home" style={{ textDecoration: "none" }}>
          <div className="sidebar-item" onClick={handleToggleSidebar}>
            <FaHome style={{ marginRight: "8px" }} />
            Home
          </div>
        </Link>
        <Link to="/chercheur-projet" style={{ textDecoration: "none" }}>
          <div className="sidebar-item">
            <FaFolder style={{ marginRight: "8px" }} />
            Competition
          </div>
        </Link>
        <Link
          to="/MyProject"
          className="sidebar-item"
          style={{ textDecoration: "none" }}
        >
          <FaFolder style={{ marginRight: "8px" }} />
          My Project
        </Link>
      </div>

      {/* Main content area */}
      <div
        style={{
          flex: 1,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "50vh",
        }}
      >
        <div
          style={{
            width: "100%",
            maxWidth: 600,
            display: "flex",
            justifyContent: "center",
            marginLeft: "35rem", 
          }}
        >
          <Card style={cardStyle}>
            <div style={headerStyle}>Mon Compte Évaluateur</div>
            <Card.Body>
              {loading ? (
                <div
                  className="d-flex justify-content-center align-items-center"
                  style={{ minHeight: "200px" }}
                >
                  <Spinner animation="border" variant="success" />
                </div>
              ) : user ? (
                <div>
                  <Row className="mb-3">
                    <Col xs={5} style={labelStyle}>
                      Nom:
                    </Col>
                    <Col xs={7} style={valueStyle}>
                      {user.nom}
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <Col xs={5} style={labelStyle}>
                      Prénom:
                    </Col>
                    <Col xs={7} style={valueStyle}>
                      {user.prenom}
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <Col xs={5} style={labelStyle}>
                      Email:
                    </Col>
                    <Col xs={7} style={valueStyle}>
                      {user.email}
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <Col xs={5} style={labelStyle}>
                      Téléphone:
                    </Col>
                    <Col xs={7} style={valueStyle}>
                      {user.telephone}
                    </Col>
                  </Row>
                  {/* Add more fields as needed */}
                </div>
              ) : (
                <div className="text-danger text-center">
                  Aucune information trouvée.
                </div>
              )}
            </Card.Body>
          </Card>
        </div>
      </div>
    </div>
  );
};
export default CompteEvaluateur;
